import { render, staticRenderFns } from "./SipTrunk.vue?vue&type=template&id=b78948b0&scoped=true"
import script from "./SipTrunk.vue?vue&type=script&lang=js"
export * from "./SipTrunk.vue?vue&type=script&lang=js"
import style0 from "./SipTrunk.vue?vue&type=style&index=0&id=b78948b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78948b0",
  null
  
)

export default component.exports